var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNotification)?_c('AlertCard',{staticClass:"alert-container",class:{ 'incoming-animation': _vm.showIncomingAnimation },attrs:{"alert":_vm.alert}}):(_vm.showUndoArchive)?_c('InboxUnarchiveNotification',{staticClass:"px-4",attrs:{"alert":_vm.alert}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }